import instance from './axios-util'

export function setAuthHeader(token: any) {
  instance.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
}

